// Reuse the task form without creating or materializing an occurrence.
export const recurringRuleDraft = (rule) => ({
  isRuleEdit: true,
  task_recurrence_rule_id: rule.id,
  task_source: "recurrence",
  summary: rule.summary_template || rule.name || "",
  description: rule.description_template || rule.description || "",
  task_type: rule.task_type,
  priority: rule.priority || "medium",
  category: rule.category || "",
  status: "new",
  rental_id: rule.rental_ids?.[0] || null,
  scheduled_start_time: rule.time_of_day,
  rule_duration_minutes: rule.duration_minutes || 60,
  assignment_mode:rule.assignment_mode || "explicit",
  work_order_assignees: (rule.default_assignees || []).map((a) => ({
    assignee_type: a.type, assignee_id: a.id, assignment_role: a.assignment_role || "assignee",
  })),
});
